import { Component } from '@angular/core';
import { Input } from '@angular/core';
import { trigger } from '@angular/animations';
import { state } from '@angular/animations';
import { style } from '@angular/animations';
import { transition } from '@angular/animations';
import { animate } from '@angular/animations';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'slideshow-image',
  template: `<img [style.max-height.rem]="maxHeight" [src]="image.url" alt="Slideshow image not found." [@imageState]="image.state" (@imageState.done)="onDone()">`,   
  styles: [
    "img { max-width: 100%; position: absolute; margin: 0 auto; left: 50%; top: 50%; transform: translateX(-50%) translateY(-50%); }"
  ],
  animations: [
    trigger('imageState', [
      state('hidden', style({
        opacity: 0
      })),
      state('visible', style({
        opacity: 1
      })),
      transition('hidden => visible', animate(1000)),
      transition('visible => hidden', animate(1000))
    ])
  ],
})

export class SlideshowImageComponent {
  @Input("max-height") maxHeight: number;
  @Input("image") image: SlideshowImage;
  @Output("done") done = new EventEmitter<SlideshowImage>();

  constructor() { }

  private onDone() {
    this.done.emit(this.image);
  }
}

export class SlideshowImage {
  url: string;
  state: string;

  constructor(url: string, state: string) {
    this.url = url;
    this.state = state;
  }
}